import { point } from '@turf/helpers';
import booleanPointInPolygon from '@turf/boolean-point-in-polygon';

/**
 * Checks if a point is within any feature of a GeoJSON.
 * @param pointCoordinates - Coordinates of the point [longitude, latitude].
 * @param geojsonString - A JSON string representing the GeoJSON.
 * @returns True if the point is within any feature, false otherwise.
 */
function isPointInsideComplexGeoJSON(
  pointCoordinates: [number, number],
  geojsonString: string
): boolean {
  try {
    // Parse GeoJSON from string
    const geojson = JSON.parse(geojsonString);

    // Create a GeoJSON Point for the input coordinates
    const pointGeoJSON = point(pointCoordinates);

    // Check if the point is inside any feature in the GeoJSON
    if (geojson.type === 'FeatureCollection') {
      // Iterate over all features in the collection
      return geojson.features.some((feature: any) => {
        return feature.geometry && booleanPointInPolygon(pointGeoJSON, feature);
      });
    } else if (geojson.type === 'Feature') {
      // Single feature case
      return booleanPointInPolygon(pointGeoJSON, geojson);
    } else {
      throw new Error('Unsupported GeoJSON type.');
    }
  } catch (error) {
    console.error('Error processing GeoJSON:', error);
    return false;
  }
}

export { isPointInsideComplexGeoJSON };